<template>
  <div id="list-transaction">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Transactions PMS</v-card-title>
          <v-card-text>
            <v-data-table
              :loading="isLoading"
              :headers="headers"
              :items="transactions.data"
              :items-per-page="10"
              :server-items-length="transactions.total"
              @update:page="listPMSTransactions"
            >
              <template v-slot:item.client="{ item }">
                <router-link
                  v-if="item.client != null"
                  :to="{
                    name: 'portail-details',
                    params: { id: item.client.id },
                  }"
                  >{{ item.client.description }}</router-link
                >
              </template>
              <template v-slot:item.cardId="{ item }">
                <router-link
                  v-if="item.cardId != null"
                  :to="{
                    name: 'cartes-details',
                    params: { id: item.cardId },
                  }"
                  >{{ item.cardId }}</router-link
                >
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ getInternationalDate(item.createdAt) }}
              </template>

              <template v-slot:item.amount="{ item }">
                <span v-if="item.amount != null && item.amount != 0">
                  {{ item.amount / 100 }}
                </span>
                {{ item.currency }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { toRefs, onMounted } from "@vue/composition-api";
import { usePMSTransaction } from "@/composables/pms-transaction";
import { useTitle } from "@/composables/title";
import { date } from "@/composables/date";

export default {
  setup() {
    const { setTitle, setIcon } = useTitle();
    setTitle("Transactions PMS");
    setIcon("pms");
    const { listPMSTransactions, pmsTransactionData } = usePMSTransaction();
    onMounted(async () => {
      await listPMSTransactions();
    });

    const { getInternationalDate } = date();

    return {
      ...toRefs(pmsTransactionData),
      headers: [
        { text: "Portail", value: "client" },
        { text: "Carte", value: "cardId" },
        { text: "Montant", value: "amount" },
        { text: "Libellé", value: "label" },
        { text: "Ref.PMS", value: "referencePMS" },
        { text: "Nom Res.", value: "reservationName" },

        { text: "Date", value: "createdAt" },
      ],
      listPMSTransactions,
      getInternationalDate,
    };
  },
};
</script>
